/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-16 08:34:34
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, change } from 'redux-form';
import { FormLayout, Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderSelect } from 'src/components/views/common/forms/render-select';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import RenderColorPickerPopover from 'src/components/views/common/render-color-picker-popover';
import { BUTTON_STYLE, QUICKVIEW_ADD_TO_CART_STYLE } from 'src/constants/layout-settings';
import { stringifyRGBASpecialFormat } from 'src/helpers/color-helper';

type Props = WithI18nProps;

class GeneralTab extends Component<Props, State> {
  render() {
    const {
      qvEnable,
      atcEnable,
      atcBtnBackgroundColor,
      atcBtnHoverBackgroundColor,
      atcBtnBorderColor,
      atcBtnHoverBorderColor,
      atcBtnTextColor,
      atcBtnHoverTextColor,
      qvBtnBackgroundColor,
      qvBtnHoverBackgroundColor,
      qvBtnBorderColor,
      qvBtnHoverBorderColor,
      qvBtnTextColor,
      qvBtnHoverTextColor,
      updateField,
      i18n
    } = this.props;
    const buttonStyle = BUTTON_STYLE.map(function(option) {
      return ({
        ...option,
        label: i18n.translate(option.label)
      })
    });

    return (
      <FormLayout>
        <Field
          name="actionlist.alStyle"
          component={RenderSelect}
          label={i18n.translate('AdminHTML.DefaultLayoutSettings.GeneralTab.field1_Label')}
          options={buttonStyle}
          onChange={(event, newValue) => this.changeButtonStyle(newValue)}
        />
        <div className="quick-view-group">
          <Field
            name="actionlist.qvEnable"
            component={RenderCheckbox}
            label={i18n.translate('AdminHTML.DefaultLayoutSettings.GeneralTab.field2_Label')}
          />
          {qvEnable && (
            <div className="groupFields">
              <Stack distribution="equalSpacing">
                <RenderColorPickerPopover
                  colorValue={qvBtnBackgroundColor}
                  fieldName="actionlist.qvBtnBackgroundColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover1_FieldLabel'
                  )}
                  updateField={updateField}
                />

                <RenderColorPickerPopover
                  colorValue={qvBtnHoverBackgroundColor}
                  fieldName="actionlist.qvBtnHoverBackgroundColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover2_FieldLabel'
                  )}
                  updateField={updateField}
                />
              </Stack>
              <Stack distribution="equalSpacing">
                <RenderColorPickerPopover
                  colorValue={qvBtnTextColor}
                  fieldName="actionlist.qvBtnTextColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover3_FieldLabel'
                  )}
                  updateField={updateField}
                />
                <RenderColorPickerPopover
                  colorValue={qvBtnHoverTextColor}
                  fieldName="actionlist.qvBtnHoverTextColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover4_FieldLabel'
                  )}
                  updateField={updateField}
                />
              </Stack>
              <Stack distribution="equalSpacing">
                <RenderColorPickerPopover
                  colorValue={qvBtnBorderColor}
                  fieldName="actionlist.qvBtnBorderColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover5_FieldLabel'
                  )}
                  updateField={updateField}
                />
                <RenderColorPickerPopover
                  colorValue={qvBtnHoverBorderColor}
                  fieldName="actionlist.qvBtnHoverBorderColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover6_FieldLabel'
                  )}
                  updateField={updateField}
                />
              </Stack>
            </div>
          )}
        </div>
        <div className="add-to-card-group">
          <Field
            name="actionlist.atcEnable"
            component={RenderCheckbox}
            label={i18n.translate('AdminHTML.DefaultLayoutSettings.GeneralTab.field3_Label')}
          />
          {atcEnable && (
            <div className="groupFields">
              <Stack distribution="equalSpacing">
                <RenderColorPickerPopover
                  colorValue={atcBtnBackgroundColor}
                  fieldName="actionlist.atcBtnBackgroundColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover1_FieldLabel'
                  )}
                  updateField={updateField}
                />
                <RenderColorPickerPopover
                  colorValue={atcBtnHoverBackgroundColor}
                  fieldName="actionlist.atcBtnHoverBackgroundColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover2_FieldLabel'
                  )}
                  updateField={updateField}
                />
              </Stack>
              <Stack distribution="equalSpacing">
                <RenderColorPickerPopover
                  colorValue={atcBtnTextColor}
                  fieldName="actionlist.atcBtnTextColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover3_FieldLabel'
                  )}
                  updateField={updateField}
                />
                <RenderColorPickerPopover
                  colorValue={atcBtnHoverTextColor}
                  fieldName="actionlist.atcBtnHoverTextColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover4_FieldLabel'
                  )}
                  updateField={updateField}
                />
              </Stack>
              <Stack distribution="equalSpacing">
                <RenderColorPickerPopover
                  colorValue={atcBtnBorderColor}
                  fieldName="actionlist.atcBtnBorderColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover5_FieldLabel'
                  )}
                  updateField={updateField}
                />
                <RenderColorPickerPopover
                  colorValue={atcBtnHoverBorderColor}
                  fieldName="actionlist.atcBtnHoverBorderColor"
                  fieldLabel={i18n.translate(
                    'AdminHTML.DefaultLayoutSettings.GeneralTab.renderColorPickerPopover6_FieldLabel'
                  )}
                  updateField={updateField}
                />
              </Stack>
            </div>
          )}
        </div>
      </FormLayout>
    );
  }

  // Change quick view and add to card fields when change button style
  changeButtonStyle = newValue => {
    const { defaultAlStyle, updateField } = this.props;
    const qv_atcStyle = QUICKVIEW_ADD_TO_CART_STYLE[newValue];
    let style = {};

    if (newValue === defaultAlStyle) {
      // reset data with style button from API
      const { initialValues } = this.props;
      const { actionlist } = initialValues;
      style = !_.isEmpty(actionlist) ? actionlist : qv_atcStyle;
    } else {
      // reset data with style button from local
      style = qv_atcStyle;
    }

    // Change fields
    [
      'qvEnable',
      'atcEnable',
      'atcBtnBackgroundColor',
      'atcBtnHoverBackgroundColor',
      'atcBtnBorderColor',
      'atcBtnHoverBorderColor',
      'atcBtnTextColor',
      'atcBtnHoverTextColor',
      'qvBtnBackgroundColor',
      'qvBtnHoverBackgroundColor',
      'qvBtnBorderColor',
      'qvBtnHoverBorderColor',
      'qvBtnTextColor',
      'qvBtnHoverTextColor'
    ].map(item => {
      return updateField(`actionlist[${item}]`, style[item]);
    });
  };
}

/**
 * Get color value from default layout settings form
 *
 * @param  {number} name name of the field to get from form
 * @param  {number} list list fields of form
 *
 * @return {string}
 */
const getColor = (name, list) => {
  let result = _.get(list, name, {
    rgb: {
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }
  });

  // Convert hsv to rgba color
  if (_.has(result, 'rgb')) {
    result = stringifyRGBASpecialFormat(result.rgb);
  }
  return result;
};

const mapStateToProps = (state, props) => {
  const formDefaultLayoutSettings = getFormValues('DefaultLayoutSettingsForm')(state);
  const qvEnable = _.get(formDefaultLayoutSettings, 'actionlist.qvEnable', false);
  const atcEnable = _.get(formDefaultLayoutSettings, 'actionlist.atcEnable', false);

  let colorList = {};
  [
    'atcBtnBackgroundColor',
    'atcBtnHoverBackgroundColor',
    'atcBtnBorderColor',
    'atcBtnHoverBorderColor',
    'atcBtnTextColor',
    'atcBtnHoverTextColor',
    'qvBtnBackgroundColor',
    'qvBtnHoverBackgroundColor',
    'qvBtnBorderColor',
    'qvBtnHoverBorderColor',
    'qvBtnTextColor',
    'qvBtnHoverTextColor'
  ].map(item => {
    colorList[item] = getColor(`actionlist.${item}`, formDefaultLayoutSettings);
    return '';
  });

  return {
    ...colorList,
    qvEnable,
    atcEnable,
    defaultAlStyle: _.get(state.filterSettings, 'filterSettings.actionlist.alStyle', 'bc-al-style4')
  };
};

const mapDispatchToProps = dispatch => ({
  updateField: (id, data) => dispatch(change(`DefaultLayoutSettingsForm`, id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(GeneralTab));
